export default __webpack_public_path__ + "static/unilabs-b1a69aebb8b27211af5dfeb2fa905c58.png";